module.exports = __webpack_public_path__ + "img/ecart-seller-white.4df70706.svg";